import { Component, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { EnterpriseService } from "../../enterprise.service";
@Component({
  selector: "app-subscription-plans",
  templateUrl: "./subscription-plans.component.html",
  styleUrls: ["./subscription-plans.component.sass"],
})
export class SubscriptionPlansComponent implements OnInit {
  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private enterpriseService: EnterpriseService
  ) {}

  ngOnInit(): void {
    this.getPlans(1);
  }

  allPlanList: any[] = [];
  activePlanType: number;

  selectedPlan: any;
  showModal: boolean = false;

  getPlans(planType: number) {
    this.spinner.show();
    this.activePlanType = planType;
    this.enterpriseService
      .getSubscriptionPlans(planType)
      .subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.allPlanList = result.data;
          console.log("all plans", this.allPlanList);
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
      });
  }

  openAddPlan() {
    this.selectedPlan = null;
    this.showModal = true;
    console.log("Show Add Model ", this.showModal);
  }
  openEditPlan(plan: any) {
    this.selectedPlan = plan;
    this.showModal = true;
    console.log("selected Plan", this.selectedPlan);
  }

  handleCloseModal() {
    this.showModal = false;
  }

  handleSave(event: any) {
    this.getPlans(this.activePlanType);
    this.showModal = false;
  }

  deletePlan(id: any) {
    this.spinner.show();
    this.enterpriseService
      .deleteSubscriptionPlan(id)
      .subscribe((result: any) => {
        if (result.statusCode == 200) {
          this.allPlanList = result.data;
          this.spinner.hide();
          this.getPlans(this.activePlanType);
          this.toastr.success(result.message);
        } else {
          this.spinner.hide();
          this.toastr.error(result.message);
        }
      });
  }
}
